/**
 * @description: 会员卡绑定合并报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="mr-hkb-report">
        <div class="member-bh-list">
            <div class="row row-margin">
                <label class="list-label-2">时间:</label>
                <div class="col-md-3 list-time">
                    <div ref="bhTime">
                        <input type="text" class="form-control laydate-icon" v-model="bhStartTime" /> -
                        <input type="text" class="form-control laydate-icon" v-model="bhEndTime" />
                    </div>
                </div>
                <label class="list-label-2">门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="bhShop" data-placeholder="请选择门店"></select>
                </div>
                <div class="col-md-1 ct-col jh-tit-sel">
                    <select class="form-control" ref="bhQuery_conditions">
                        <option value="main_vip_card">主卡号</option>
                        <option value="merged_vip_card">被合并卡号</option>
                        <option value="ahead_user_name">微信昵称</option>
                        <option value="mobile">手机号</option>
                    </select>
                </div>
                <div class="col-md-2 jh-con-val">
                    <input type="text" class="form-control" v-model="bhSearch_info" :placeholder="bhEmployeeinput">
                </div>
                <div>
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="innitBhTable" style="margin-right: 10px">查询</button>
                    <button type="button" class="btn btn-flat btn-small btn-border-gray" @click="getBhExportSet">导出</button>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="bhList"></table>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="bhExport_alert">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='bhExport_allcheck' @click='bhExportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='bhExport_checkModel' value="shop_name">
                            <label>门店</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='bhExport_checkModel' value="mobile">
                            <label>会员手机号</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='bhExport_checkModel' value="ahead_user_name">
                            <label>微信昵称</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='bhExport_checkModel' value="main_vip_card">
                            <label>主卡号</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='bhExport_checkModel' value="merged_vip_card">
                            <label>被合并卡号</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='bhExport_checkModel' value="merged_account">
                            <label>被合并通用账户余额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='bhExport_checkModel' value="merged_room_account">
                            <label>被合并房费账户余额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='bhExport_checkModel' value="merged_present_account">
                            <label>被合并赠送账户余额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='bhExport_checkModel' value="merged_points">
                            <label>被合并会员卡积分</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='bhExport_checkModel' value="create_time">
                            <label>操作时间</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix">
                        <li>
                            <input type="radio" v-model='bhExport_type' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='bhExport_type' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                bhStartTime: "",
                bhEndTime: "",
                bhEmployeeinput: '请输入主卡号',
                bhSearch_field: "main_vip_card",
                bhSearch_info: "",
                bhExport_allcheck: false,
                c_bhExport_allcheck: false,
                bhExport_checkModel: [],
                bhExport_checkData: ['shop_name', 'mobile', 'ahead_user_name', 'main_vip_card', 'merged_vip_card', 'merged_account', 'merged_room_account', 'merged_present_account', 'merged_points', 'create_time'],
                bhExport_type: 1,
            }
        },
        watch: {
            bhExport_checkModel: {
                handler: function (val, oldVal) {
                    if(this.bhExport_checkModel.length >= this.bhExport_checkData.length) {
                        this.bhExport_allcheck = true;
                        this.c_bhExport_allcheck = true;
                    } else {
                        this.bhExport_allcheck = false;
                        this.c_bhExport_allcheck = false;
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            const _this = this
            // 日期
            _this.bhStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            _this.bhEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            _this.innitDate(); // 日期
            _this.shopDatas = [];
            _this.innitInput();  // 门店
            // 下拉选项
            $(_this.$refs.bhQuery_conditions).select2({
                language: "zh-CN",
                minimumResultsForSearch: -1
            }).change(function() {
                _this.bhSearch_field = $(this).val();
                if(_this.bhSearch_field == 'main_vip_card') {
                    _this.bhEmployeeinput = '请输入主卡号';
                } else if(_this.bhSearch_field == 'merged_vip_card') {
                    _this.bhEmployeeinput = '请输入被合并卡号';
                } else if(_this.bhSearch_field == 'ahead_user_name') {
                    _this.bhEmployeeinput = '请输入微信昵称';
                } else if(_this.bhSearch_field == 'mobile') {
                    _this.bhEmployeeinput = '请输入手机号';
                }
            });
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.bhStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.bhEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.bhStartTime = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.bhEndTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                const _this = this;
                $(_this.$refs.bhTime).daterangepicker({
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().hour(8).minute(0).toDate(),
                    endDate: moment().add(1, 'day').hour(8).minute(0).toDate(),
                    dateLimit : {
                        days : 31
                    },
                }, function(start, end, label) {
                    _this.bhStartTime = start.format('YYYY-MM-DD HH:mm');
                    _this.bhEndTime = end.format('YYYY-MM-DD HH:mm');
                });
            },
            // 初始化门店输入框
            innitInput: function() {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": "1",
                            "page_size": "0",
                            "name": "",
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $.each(data.response.result, function(k, v) {
                                _this.shopDatas.push({
                                    id: v.id,
                                    text: v.name
                                });
                            });
                            $(_this.$refs.bhShop).select2({
                                data: _this.shopDatas,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            }).on("select2:select", function(e) {
                                _this.setShopDefaultTime(e.params.data.id)
                            });
                            $(_this.$refs.bhShop).val(data.response.result[1].id).trigger('change');
                            _this.setShopDefaultTime(data.response.result[1].id)
                            _this.innitBhTable();
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },



            // 初始化会员卡绑定合并报表
            innitBhTable: function() {
                let _this = this;
                $(_this.$refs.bhList).bootstrapTable('destroy');
                $(_this.$refs.bhList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getBhList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "index",
                        title: "行号",
                        width: "6%",
                        valign: "middle",
                        formatter: function(value, row, index) {
                            return index + 1;
                        }
                    }, {
                        field: "shop_name",
                        title: "门店",
                        width: "130",
                        valign: "middle",
                        formatter: function(value, row, index) {
                            return value.length > '14' ? value.slice(0, 14) + '...' : value
                        }
                    }, {
                        field: "mobile",
                        title: "会员手机号",
                        width: "9%",
                        valign: "middle"
                    }, {
                        field: "ahead_user_name",
                        title: "微信昵称",
                        width: "9%",
                        valign: "middle"
                    }, {
                        field: "main_vip_card",
                        title: "主卡号",
                        width: "110",
                        valign: "middle"
                    }, {
                        field: "merged_vip_card",
                        title: "被合并卡号",
                        width: "110",
                        valign: "middle"
                    }, {
                        field: "merged_account",
                        title: "被合并<br />通用账户余额",
                        width: "9%",
                        valign: "middle"
                    }, {
                        field: "merged_room_account",
                        title: "被合并<br />房费账户余额",
                        width: "9%",
                        valign: "middle"
                    }, {
                        field: "merged_present_account",
                        title: "被合并<br />赠送账户余额",
                        width: "9%",
                        valign: "middle"
                    }, {
                        field: "merged_points",
                        title: "被合并<br />会员卡积分",
                        width: "9%",
                        valign: "middle"
                    }, {
                        field: "create_time",
                        title: "操作时间",
                        width: "100",
                        valign: "middle"
                    }]
                });
            },
            // 获取会员卡绑定合并报表列表
            getBhList: function(params) {
                let _this = this,
                    shop_id = $(_this.$refs.bhShop).val(),
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let main_vip_card = '',
                    merged_vip_card = '',
                    ahead_user_name = '',
                    mobile = '';
                if(_this.bhSearch_field == 'main_vip_card') {
                    main_vip_card = _this.bhSearch_info;
                } else if(_this.bhSearch_field == 'merged_vip_card') {
                    merged_vip_card = _this.bhSearch_info;
                } else if(_this.bhSearch_field == 'ahead_user_name') {
                    ahead_user_name = _this.bhSearch_info;
                } else if(_this.bhSearch_field == 'mobile') {
                    mobile = _this.bhSearch_info;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "start_time": _this.bhStartTime,
                            "end_time": _this.bhEndTime,
                            "shop_id": shop_id,
                            "main_vip_card": main_vip_card,
                            "merged_vip_card": merged_vip_card,
                            "ahead_user_name": ahead_user_name,
                            "mobile": mobile
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getVipMergeReport",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.total,
                                rows: data.response.result.rows
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取导出设置
            getBhExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "FinanceReport/vipMergeReportExport"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.bhExport_checkModel = data.response.result.export_fields;
                                _this.bhExport_type = data.response.result.export_type;
                            } else {
                                _this.bhExport_checkModel = _this.bhExport_checkData;
                                _this.bhExport_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.bhExport_alert)
                }, function() {
                    _this.exportBhList();
                });
            },
            // 导出字段全选
            bhExportCheckedAll: function() {
                let _this = this;
                _this.bhExport_allcheck = _this.c_bhExport_allcheck;
                if(!_this.bhExport_allcheck) { // 实现全选
                    _this.bhExport_checkModel = [];
                    _this.bhExport_checkData.forEach(function(item) {
                        _this.bhExport_checkModel.push(item);
                    });
                } else { // 实现反选
                    _this.bhExport_checkModel = [];
                }
            },
            // 确定“导出”
            exportBhList: function() {
                let _this = this,
                    shop_id = $(_this.$refs.bhShop).val();
                let export_fields = JSON.stringify(_this.bhExport_checkModel);
                let main_vip_card = '',
                    merged_vip_card = '',
                    ahead_user_name = '',
                    mobile = '';
                if(_this.bhSearch_field == 'main_vip_card') {
                    main_vip_card = _this.bhSearch_info;
                } else if(_this.bhSearch_field == 'merged_vip_card') {
                    merged_vip_card = _this.bhSearch_info;
                } else if(_this.bhSearch_field == 'ahead_user_name') {
                    ahead_user_name = _this.bhSearch_info;
                } else if(_this.bhSearch_field == 'mobile') {
                    mobile = _this.bhSearch_info;
                }
                window.location.href = Vue.ctUrl + "FinanceReport/vipMergeReportExport?" +
                    "&start_time=" + _this.bhStartTime +
                    "&end_time=" + _this.bhEndTime +
                    "&shop_id=" + shop_id +
                    "&main_vip_card=" + main_vip_card +
                    "&merged_vip_card=" + merged_vip_card +
                    "&ahead_user_name=" + ahead_user_name +
                    "&mobile=" + mobile +
                    "&export_fields=" + export_fields +
                    "&export_type=" + _this.bhExport_type;
                // debugger;
                layer.msg("导出成功！");
                layer.closeAll();
            },
        }
    }
</script>
<style lang="less" scoped>
    .member-bh-list {
        .fixed-table-body {
            overflow-x: scroll;
            table {
                width: 1300px;
                word-break: break-all;
            }
        }
        .fixed-table-body::-webkit-scrollbar {
            position: absolute;
            top: 0;
            left: 0;
            height: 30px;
        }
    }
</style>